import { ElementType, FC, ReactNode } from 'react';

import { StyledSkeleton, StyledSkeletonContent } from './Skeleton.styles';

export interface Props {
	height?: string;
	width?: string;
	children?: ReactNode;
	as?: ElementType;
	isLoading?: boolean;
}

export const Skeleton: FC<Props> = ({ children, height, width, as, isLoading = true, ...rest }) => (
	<StyledSkeleton as={as} height={height} width={width} isLoading={isLoading} {...rest}>
		<StyledSkeletonContent isLoading={isLoading}>{children}</StyledSkeletonContent>
	</StyledSkeleton>
);
